/* Venocci – "Kişiselleştir" bileşeni (venocci.com "Customize now" bileşeninin Türkçe uyarlaması).
   Yalnızca product.masaustu-organizer-kisisellestir şablonundaki snippet tarafından yüklenir. */
(function () {
  'use strict';
  if (window.__vncVc) return;
  window.__vncVc = true;

  var instances = {};

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function low(s) { return String(s || '').toLocaleLowerCase('tr-TR'); }

  /* Kişiselleştirme alanı türü: both | left | right | none */
  function areaKind(v) {
    var s = low(v);
    if (!s) return '';
    if (s.indexOf('istemiyorum') > -1 || s.indexOf('yok') > -1) return 'none';
    if (s.indexOf('her iki') > -1) return 'both';
    if (s.indexOf('sol') > -1) return 'left';
    if (s.indexOf('sağ') > -1) return 'right';
    return '';
  }

  function formatMoney(cents, format) {
    var c = Number(cents) || 0;
    function fmt(n, d, ts, ds) {
      var p = (n / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return d ? p[0] + ds + p[1] : p[0];
    }
    var f = format || '{{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(c, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(c, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(c, 2, "'", '.');
        default: return fmt(c, 2, ',', '.');
      }
    });
  }

  function init(root) {
    var cfgEl = q('script[data-vc-config]', root);
    if (!cfgEl) return;
    var C;
    try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var pid = String(C.productId);

    /* Tema varyant değişiminde bölümü yeniden çizerse: mevcut modal korunur, yeni kopyası atılır */
    if (instances[pid]) {
      var dup = q('[data-vc-modal]', root);
      if (dup && dup !== instances[pid].modal) dup.remove();
      return;
    }

    var modal = q('[data-vc-modal]', root);
    if (!modal) return;
    document.body.appendChild(modal);
    var box = q('.vc-box', modal);
    function M(s) { return q(s, modal); }
    function MM(s) { return qa(s, modal); }

    var opts = (C.selected || []).slice();
    var files = {};
    var areaSec = M('[data-vc-areaopt]');

    function variant() {
      return C.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function areaVal() { return C.areaIndex >= 0 ? opts[C.areaIndex] : ''; }
    function isNone() { return !!areaSec && areaKind(areaVal()) === 'none'; }
    function isBoth() { return !!areaSec && areaKind(areaVal()) === 'both'; }

    function setChip(sec, val) {
      qa('.vc-chip', sec).forEach(function (b) {
        var on = b.dataset.value === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { var l = q('[data-vc-olabel]', sec); if (l) l.textContent = b.dataset.label || val; }
      });
    }

    function render() {
      var v = variant();
      M('[data-vc-price]').textContent = v ? formatMoney(v.price, C.moneyFormat) : '—';
      var add = M('[data-vc-add]');
      add.disabled = !v || !v.available;
      add.textContent = !v ? 'Mevcut değil' : (v.available ? 'Sepete ekle' : 'Tükendi');
      var none = isNone(), kind = areaKind(areaVal());
      var side = (areaSec && !none && (kind === 'left' || kind === 'right')) ? kind : '';
      var ts = M('[data-vc-textsec]'); if (ts) ts.hidden = none;
      MM('[data-vc-field]').forEach(function (f) { f.hidden = none || (!!side && f.dataset.keyword !== side); });
      var ls = M('[data-vc-logosec]');
      if (ls) {
        var any = false;
        qa('[data-vc-logo]', ls).forEach(function (el) {
          var show = !none && !(side && el.dataset.keyword !== side);
          el.hidden = !show; if (show) any = true;
        });
        ls.hidden = none || !any;
      }
      MM('[data-vc-option]').forEach(function (sec) {
        var i = Number(sec.dataset.vcOption);
        qa('.vc-chip', sec).forEach(function (b) {
          var o = opts.slice(); o[i] = b.dataset.value;
          var match = C.variants.filter(function (x) { return x.options.every(function (y, k) { return y === o[k]; }); })[0];
          b.classList.toggle('is-na', !match || !match.available);
        });
      });
    }

    /* Sayfadaki (gizli) tema varyant seçicisiyle eşitleme */
    function pageForm() { return document.getElementById(C.formId); }
    function pageVariantId() {
      var f = pageForm(), inp = f && f.querySelector('[name="id"]');
      if (inp && inp.value) return inp.value;
      var m = location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }
    function syncFromPage() {
      var id = pageVariantId();
      var v = id && C.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (v) opts = v.options.slice();
      MM('[data-vc-option]').forEach(function (sec) { setChip(sec, opts[Number(sec.dataset.vcOption)]); });
      render();
    }
    function syncToPage() {
      var v = variant(); if (!v) return;
      if (String(pageVariantId()) === String(v.id)) return;
      var picker = document.querySelector('[id^="VariantPicker-"][id$="-' + pid + '"]');
      if (!picker) return;
      var changed = null;
      v.options.forEach(function (val, i) {
        var wrap = picker.querySelector('[data-option-index="option' + (i + 1) + '"]');
        var sel = wrap && wrap.querySelector('select');
        if (sel && sel.value !== val) { sel.value = val; changed = sel; }
        var radio = wrap && wrap.querySelector('input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
        if (radio && !radio.checked) { radio.checked = true; changed = radio; }
      });
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var lastFocus = null;
    function open() {
      syncFromPage();
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      try { box.focus({ preventScroll: true }); } catch (e) {}
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    qa('[data-vc-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

    /* Seçenekler */
    MM('[data-vc-option]').forEach(function (sec) {
      var i = Number(sec.dataset.vcOption);
      qa('.vc-chip', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          opts[i] = b.dataset.value; setChip(sec, b.dataset.value); render(); syncToPage();
        });
      });
    });

    /* Ek seçenek (ör. saat şarj yuvası): varyant değil, satır özelliği olarak gönderilir */
    MM('[data-vc-extra]').forEach(function (sec) {
      qa('.vc-chip', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          qa('.vc-chip', sec).forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var l = q('[data-vc-olabel]', sec); if (l) l.textContent = b.dataset.label || b.dataset.value;
        });
      });
    });

    /* Metin alanları (karakter sınırı yok) */
    var err = M('[data-vc-err]'), fields = MM('[data-vc-field]');
    function clearErr() { fields.forEach(function (f) { q('input', f).classList.remove('is-bad'); }); err.hidden = true; }
    fields.forEach(function (f) {
      q('input', f).addEventListener('input', function () {
        if (this.value.trim()) {
          this.classList.remove('is-bad');
          if (!fields.some(function (x) { return q('input', x).classList.contains('is-bad'); })) err.hidden = true;
        }
      });
    });

    /* Logo (PNG/JPG/JPEG, en fazla 5 MB) */
    var ferr = M('[data-vc-ferr]');
    MM('[data-vc-logo]').forEach(function (el) {
      var inp = q('[data-vc-file]', el), nm = q('[data-vc-fname]', el), rm = q('[data-vc-rm]', el), id = el.dataset.vcLogo, def = nm.textContent;
      var pbox = q('[data-vc-prev-box]', el), pimg = q('[data-vc-prev-img]', el), purl = null;
      function reset() {
        inp.value = ''; delete files[id]; nm.textContent = def; el.classList.remove('has-file'); pbox.hidden = true;
        if (purl) { URL.revokeObjectURL(purl); purl = null; } pimg.removeAttribute('src');
      }
      inp.addEventListener('change', function () {
        var f = inp.files[0]; if (ferr) ferr.hidden = true;
        if (!f) { reset(); return; }
        var okType = /image\/(png|jpe?g)/.test(f.type) || /\.(png|jpe?g)$/i.test(f.name);
        if (!okType || f.size > 5 * 1024 * 1024) {
          reset();
          if (ferr) { ferr.textContent = 'Lütfen en fazla 5 MB boyutunda PNG veya JPG/JPEG görsel yükleyin.'; ferr.hidden = false; }
          return;
        }
        files[id] = f; nm.textContent = '✓ ' + f.name; el.classList.add('has-file'); clearErr();
        if (purl) URL.revokeObjectURL(purl); purl = URL.createObjectURL(f); pimg.src = purl; pbox.hidden = false;
      });
      rm.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); reset(); });
    });

    /* Sepete ekle */
    M('[data-vc-add]').addEventListener('click', function () {
      var v = variant(); if (!v) return;
      var none = isNone();
      var vis = fields.filter(function (f) { return !f.hidden; });
      var filled = vis.filter(function (f) { return q('input', f).value.trim(); });
      var logos = MM('[data-vc-logo]').filter(function (el) { return !el.hidden && files[el.dataset.vcLogo]; });
      function sideDone(f) {
        if (q('input', f).value.trim()) return true;
        var k = f.dataset.keyword;
        return logos.some(function (el) { return k && el.dataset.keyword === k; });
      }
      var bad = [], msg = '';
      if (!none && C.required) {
        if (isBoth()) { bad = vis.filter(function (f) { return !sideDone(f); }); msg = C.msgBoth; }
        else if (!filled.length && !logos.length) { bad = vis; msg = C.msgText; }
      }
      if (bad.length) {
        bad.forEach(function (f) { q('input', f).classList.add('is-bad'); });
        err.textContent = msg; err.hidden = false;
        bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        q('input', bad[0]).focus({ preventScroll: true });
        return;
      }
      var fd = new FormData();
      fd.append('id', v.id);
      fd.append('quantity', M('[data-vc-qty]').value);
      if (!none) {
        filled.forEach(function (f) { fd.append('properties[' + f.dataset.prop + ']', q('input', f).value.trim()); });
        logos.forEach(function (el) { fd.append('properties[' + el.dataset.prop + ']', files[el.dataset.vcLogo]); });
      }
      MM('[data-vc-extra]').forEach(function (sec) {
        var on = q('.vc-chip.is-on', sec);
        if (on && sec.dataset.prop) fd.append('properties[' + sec.dataset.prop + ']', on.dataset.value);
      });
      var btn = M('[data-vc-add]'), st = M('[data-vc-status]');
      btn.disabled = true; btn.textContent = 'Ekleniyor…'; st.textContent = '';
      fetch(String(C.root || '/').replace(/\/$/, '') + '/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Ürün sepete eklenemedi.'); return d; }); })
        .then(function () {
          syncToPage();
          if (C.toCart) { window.location.href = C.cartUrl || '/cart'; return; }
          st.style.color = '#067D62'; st.textContent = '✓ Sepete eklendi';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(close, 900); render();
        })
        .catch(function (e) { st.style.color = '#B12704'; st.textContent = e.message; render(); });
    });

    /* Sayfadaki tema "Sepete ekle" düğmesi: kişiselleştirmeli varyantta önce bu pencere açılır */
    function guard(e) {
      var f = pageForm(); if (!f) return;
      var t = e.target;
      var isForm = e.type === 'submit' && t === f;
      var isBtn = e.type === 'click' && t.closest && t.closest('button[type="submit"], [name="add"]') &&
        ((t.closest('form') === f) || (t.closest('[form]') && t.closest('[form]').getAttribute('form') === C.formId));
      if (!isForm && !isBtn) return;
      var id = pageVariantId();
      var v = id && C.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (v && areaKind(v.options[C.areaIndex]) === 'none') return;
      e.preventDefault(); e.stopImmediatePropagation();
      open();
    }
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);

    instances[pid] = { modal: modal, open: open, close: close };
    render();
  }

  /* Tetikleyici: tema bölümü yeniden çizse bile çalışsın diye belge düzeyinde dinlenir */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vc-open]');
    if (!b) return;
    var root = b.closest('[data-vc-root]');
    var inst = root && instances[root.dataset.productId];
    if (inst) { e.preventDefault(); inst.open(); }
  });

  function scan() { qa('[data-vc-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scan(); break; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
